import { Component, HostListener, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-specifications-popup',
  templateUrl: './specifications-popup.component.html',
  styleUrls: ['./specifications-popup.component.scss']
})
export class SpecificationsPopupComponent implements OnInit {
  @Input() showPopup = false;
  activeSection = '';
  currentSection: string;

  sections = [
    {
      id: 'dimensions',
      name: 'Dimensions & Capacity',
      rows: [
        { title: 'Length', value: '2500 mm' },
        { title: 'Width', value: '1500 mm' },
        { title: 'Height', value: '2000 mm' }
      ]
    },
    {
      id: 'engine',
      name: 'Engine & Transmission',
      rows: [
        { title: 'Engine Type', value: 'Inline-4' },
        { title: 'Displacement', value: '2.0 L' },
        { title: 'Transmission', value: 'Automatic' }
      ]
    },
    {
      id: 'fuel',
      name: 'Fuel Performance',
      rows: [
        { title: 'Fuel Type', value: 'Petrol' },
        { title: 'Fuel Tank Capacity', value: '60 liters' },
        { title: 'Mileage', value: '15 km/l' }
      ]
    },
    {
      id: 'suspension',
      name: 'Suspension & Brakes',
      rows: [
        { title: 'Suspension Type', value: 'MacPherson Strut' },
        { title: 'Brake Type', value: 'Disc brakes' },
        { title: 'ABS', value: 'Yes' }
      ]
    }
  ];

  ngOnInit(): void {
    this.currentSection = 'dimensions'; // Default section
  }

  closePopup() {
    this.showPopup = false;
  }

  selectSection(sectionId: string) {
    this.activeSection = sectionId;
    this.scrollToSection(sectionId);
  }

  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }
}
